import { inject, observer } from "mobx-react";
import "moment-timezone";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { compose } from "recompose";
import CallOutcomeModal from "../Voice/CallOutcomeModal";

class Dialer extends Component {
  constructor(props) {
    super(props);
    this.state = { showHelpbox: true };
    props.dialerStore.init();
  }

  selectSuggestion = suggestion => {
    this.props.dialerStore.dialerNumber = suggestion.number;
    this.props.dialerStore.suggestedNumbers = [];
  };

  render() {
    const dialer = this.props.dialerStore;
    const dclass = dialer.showDialer ? "dialer dialer-open" : "dialer";

    if (!dialer.initialised)
      return (
        <div className={dclass}>
          <div>Initialising</div>
        </div>
      );

    const busyStatus = dialer.dialerStatus === "busy" && dialer.currentCall && (
      <div className="call">
        <div>
          <i style={{ margin: "5px 0" }} className="far fa-phone fa-2x"></i>
        </div>
        <div>
          <div>{dialer.currentCallDuration}</div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 0, padding: 5 }}>
              <Button
                bsStyle="danger"
                bsSize="small"
                onClick={() => dialer.disconnect()}
              >
                Hang Up
              </Button>
            </div>
            <div style={{ flex: 0, padding: 5 }}>
              <Button
                bsStyle="info"
                bsSize="small"
                onClick={() => dialer.putCallOnHold()}
              >
                Put on Hold
              </Button>
            </div>
          </div>
        </div>
      </div>
    );

    const offlineStatus = dialer.dialerStatus === "offline" && (
      <div>
        <Button bsStyle="info" bsSize="small" onClick={() => dialer.init()}>
          Reconnect
        </Button>
      </div>
    );

    const incomingConnectionsStatus =
      dialer.dialerStatus === "incoming" &&
      dialer.incomingConnections.map(incoming => (
        <div className="call" key={incoming.callRecordID}>
          <div>
            <i
              style={{ margin: "5px 0" }}
              className="far fa-phone faa-horizontal-shake animated fa-2x"
            ></i>
          </div>
          <div>
            <div>
              {incoming.callRecordContactID ? (
                <Link to={`/m1/contacts/${incoming.callRecordContactID}`}>
                  {incoming.callRecordName}
                </Link>
              ) : (
                incoming.callRecordName
              )}
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 0, padding: 5 }}>
                <Button
                  bsStyle="success"
                  bsSize="small"
                  onClick={() => dialer.acceptIncoming(incoming)}
                >
                  Accept Call
                </Button>
              </div>
              <div style={{ flex: 0, padding: 5 }}>
                <Button
                  bsStyle="danger"
                  bsSize="small"
                  onClick={() => dialer.rejectIncoming(incoming)}
                >
                  Ignore Call
                </Button>
              </div>
            </div>
          </div>
        </div>
      ));

    const readyToDialStatus = dialer.dialerStatus === "readyToDial" && (
      <div>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Number to call ..."
            value={dialer.dialerNumber}
            onChange={e => (dialer.dialerNumber = e.target.value)}
          />
          <span className="input-group-btn">
            <Button
              bsStyle="info"
              disabled={!dialer.isValidDialNumber()}
              onClick={() => dialer.dial()}
            >
              Dial
            </Button>
          </span>
        </div>
      </div>
    );

    const onHoldStatus = dialer.dialerStatus === "on_hold" && (
      <div>
        <div>
          <label>On Hold Calls</label>
          {dialer.onHoldCalls.length === 0 && <div>Nobody on hold</div>}
          {dialer.onHoldCalls.length > 0 && (
            <div>
              {dialer.onHoldCalls.map(call => {
                return (
                  <div
                    key={call.queue_name}
                    style={{
                      border: "1px solid #ccc",
                      padding: 5,
                      marginBottom: 5
                    }}
                  >
                    <div>
                      <strong>Contact:</strong>
                    </div>
                    <div style={{ margin: "0 0 5px 0" }}>
                      {call.contact_number}
                    </div>
                    <div>
                      <strong>Put On Hold By:</strong>
                    </div>
                    <div style={{ margin: "0 0 5px 0" }}>
                      {call.m1_user_email}
                    </div>
                    <div className="clearfix" style={{ margin: "5px 0 0 0" }}>
                      <Button
                        bsStyle="success"
                        bsSize="xsmall"
                        className="pull-right"
                        onClick={() => dialer.pickUpHold(call.queue_name)}
                      >
                        Pick Up Call
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="clearfix" style={{ margin: "5px 0 0 0" }}>
          <Button
            bsStyle="link"
            bsSize="xsmall"
            className="pull-right"
            onClick={dialer.hideOnHold}
          >
            Close
          </Button>
        </div>
      </div>
    );

    const optionsStatus = dialer.dialerStatus === "options" && (
      <div>
        <div>
          <label>Your status</label>
          <select
            className="form-control"
            id="assigned"
            value={dialer.userStatus}
            onChange={e => {
              dialer.userStatus = e.target.value;
            }}
          >
            <option value="Available">Available</option>
            <option value="Busy">Busy</option>
          </select>
        </div>
        <div className="clearfix" style={{ margin: "5px 0 0 0" }}>
          <Button
            bsStyle="info"
            bsSize="xsmall"
            className="pull-right"
            onClick={dialer.hideOptions}
          >
            Close Options
          </Button>
        </div>
      </div>
    );

    const callerID = this.state.showHelpbox && dialer.callerID && (
      <div className="helpbox">
        <i
          className="far fa-times pull-right"
          style={{ cursor: "pointer" }}
          onClick={() => this.setState({ showHelpbox: false })}
        ></i>
        {dialer.callerID.first_name && <div>{dialer.callerID.first_name}</div>}
        <div>
          <Link to={`/m1/contacts/${dialer.callerID.id}`}>
            {dialer.callerID.email || dialer.callerID.mobile}
          </Link>
        </div>

        {dialer.callerID.related_deals.map((deal, index) => (
          <span style={{ marginRight: 10 }} key={index}>
            <Link to={`/m1/deals/${deal.id}`}>Deal #{deal.id}</Link>
          </span>
        ))}

        {dialer.callerID.follow_ups.map((follow_up, index) => (
          <span style={{ marginRight: 10 }} key={index}>
            <Link to={`/m1/follow_ups/${follow_up.id}`}>
              Follow up #{follow_up.id}
            </Link>
          </span>
        ))}
      </div>
    );

    const callerStatus = this.state.showHelpbox &&
      dialer.dialerStatus === "readyToDial" &&
      dialer.suggestedNumbers.length > 0 && (
        <div className="helpbox">
          {dialer.suggestedNumbers.length > 0 && (
            <div className="suggestions">
              <div className="title">
                Suggestions{" "}
                <i
                  className="far fa-times pull-right"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.setState({ showHelpbox: false })}
                ></i>
              </div>
              {dialer.suggestedNumbers.map(suggestion => {
                return (
                  <div
                    key={suggestion.id}
                    className="suggestion"
                    onClick={() => this.selectSuggestion(suggestion)}
                  >
                    <div>
                      {suggestion.name} {suggestion.number}
                    </div>
                    <div>{suggestion.email || "<unknown email>"}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );

    return (
      <div className={dclass}>
        {callerStatus}
        {callerID}
        <div className="dialbox">
          <div className="title">
            {dialer.userStatus}
            {
              <i
                className="far fa-times pull-right"
                style={{ cursor: "pointer", marginLeft: 10, marginTop: 5 }}
                onClick={() => dialer.closeDialer()}
              ></i>
            }
            <span className="pull-right">
              {!dialer.showOnHold && dialer.dialerStatus === "readyToDial" && (
                <span
                  style={{ cursor: "pointer", marginLeft: 10, marginTop: 5 }}
                  onClick={() => dialer.displayOnHold()}
                >
                  {dialer.onHoldCalls.length > 0 && (
                    <>
                      <i className="far fa-phone"></i>{" "}
                      <span className="badge badge-warning">
                        {dialer.onHoldCalls.length}
                      </span>
                    </>
                  )}
                  {dialer.onHoldCalls.length === 0 && (
                    <i className="far fa-phone-slash"></i>
                  )}
                </span>
              )}
              {!dialer.showOptions && dialer.dialerStatus === "readyToDial" && (
                <i
                  className="far fa-cog "
                  style={{ cursor: "pointer", marginLeft: 10, marginTop: 5 }}
                  onClick={() => dialer.displayOptions()}
                ></i>
              )}
              {!this.state.showHelpbox && (
                <i
                  className="far fa-info "
                  style={{ cursor: "pointer", marginLeft: 10, marginTop: 5 }}
                  onClick={() => this.setState({ showHelpbox: true })}
                ></i>
              )}
            </span>
          </div>
          <div className="body">
            {incomingConnectionsStatus}
            {readyToDialStatus}
            {busyStatus}
            {offlineStatus}
            {onHoldStatus}
            {optionsStatus}
          </div>
        </div>

        <CallOutcomeModal
          showModal={dialer.showOutcomeModal}
          isIncoming={dialer.pendingOutcomeIsIncoming}
          onSubmit={(outcome, isTCSCall) => dialer.submitCallOutcome(outcome, isTCSCall)}
        />
      </div>
    );
  }
}

export default compose(inject("dialerStore"))(observer(Dialer));
